import { useCallback, useSyncExternalStore } from 'react';
import { AppearanceManager } from '@/managers/appearance-manager';
import { Appearance, AppearanceType } from '@/constants';

interface UseAppearance {
	appearance: AppearanceType;
	isDark: boolean;
	setAppearance: (theme: AppearanceType) => void;
	toggleAppearance: () => void;
}

const subscribe = (listener: () => void) => AppearanceManager.subscribe(listener);
const getSnapshot = () => AppearanceManager.getAppearance();

export function useAppearance(): UseAppearance {
	const appearance = useSyncExternalStore(subscribe, getSnapshot, getSnapshot);

	const setAppearance = useCallback((theme: AppearanceType) => AppearanceManager.setAppearance(theme), []);
	const toggleAppearance = useCallback(() => AppearanceManager.toggle(), []);

	return {
		appearance,
		isDark: appearance === Appearance.DARK,
		setAppearance,
		toggleAppearance
	};
}
